import { render, staticRenderFns } from "./type0.vue?vue&type=template&id=3f689e2d&scoped=true&"
import script from "./type0.vue?vue&type=script&lang=js&"
export * from "./type0.vue?vue&type=script&lang=js&"
import style0 from "./type0.vue?vue&type=style&index=0&id=3f689e2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f689e2d",
  null
  
)

export default component.exports